<template>
    <div class="container flex flex-col gap-5 lg:gap-8 pb-10 lg:pb-20">
        <h1 v-if="title">{{ title }}</h1>
        <p class="text-text-subtle text-2xl" v-if="entry">{{ entry }}</p>

        <div class="grid lg:grid-cols-2">
            <div>
                <Link
                    v-for="link in navigationLinks"
                    v-epi-edit="'HeroLinks'"
                    :key="link.title"
                    :href="link.href"
                    :text="link.text"
                    :target="link.target"
                    :title="link.title"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Link from '@/Scripts/components/atoms/Link/Link.vue';

export default {
    props: ['title', 'entry', 'navigationLinks'],
    components: {
        Link,
    }
};
</script>
